import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames as fetchTableColumnNames, 
  getAllCountry, 
  activeDeactiveCountry as toggleCountryStatusAPI,
  updateCountryAPI,
} from "../../helpers/fakebackend_helper";
import { t } from "i18next";
import { toast } from "react-toastify";



// Fetch Logs Table Column Names
export const fetchCountryTableColumnNames = createAsyncThunk(
  "country/fetchTableColumnNames",
  async (country, thunkAPI) => {
    try {
      const response = await fetchTableColumnNames(country); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch Logs data
export const fetchAllCountry = createAsyncThunk("country/fetch", async (country, thunkAPI) => {
  try {
    const response = await getAllCountry(country);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Activate/Deactivate Country
export const toggleCountryStatus = createAsyncThunk(
  "country/toggleStatus",
  async (countryData, thunkAPI) => {
    try {
      const response = await toggleCountryStatusAPI(countryData);
      toast.success(t(response.Message));
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch Logs data
export const updateCountry = createAsyncThunk("country/updateCountry", async (country, thunkAPI) => {
  try {
    const response = await updateCountryAPI(country);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});
